import { createSelector } from '@reduxjs/toolkit';

import { TApplicationState } from 'shared/types/redux';
import { hasValidPhone } from '../../utils/agent';

export const sellersSelector = (state: TApplicationState) => {
  return state.newbuilding.sellers;
};

export function sellersWithPhonesSelector(state: TApplicationState) {
  const {
    newbuilding: { sellers },
  } = state;

  if (sellers) {
    return sellers.filter(seller => seller.showPhone && seller.phone);
  }

  return [];
}

export const sellersWithValidPhonesSelector = createSelector([sellersSelector], sellers =>
  sellers.filter(hasValidPhone),
);
